module.exports = __webpack_public_path__ + "img/documentos-negociados.32deb371.svg";